import { moduleNames } from 'pages/Stores/components/modules';
import { uploadMedia } from 'utils/mediaResourceUtils';
import { BANNER_MODES, createBannerConfig } from './BannerConfig';

const defaultValues = {
  mode: BANNER_MODES.EXISTING,
  selectedItems: [],
  name: '',
  image: [],
  existing_image_id: null,
  existing_image_url: null,
  url: '',
};

export const createBannerModule = (useAvailableItems) => ({
  moduleName: moduleNames.BANNER,
  nameTranslationPath: 'banners.title',
  descriptionTranslationPath: 'banners.moduleDescription',
  iconClassName: 'bi bi-card-image',
  defaultValues,
  isValid: (values) => {
    if (values.mode === BANNER_MODES.CUSTOM) {
      return (
        !!values.name?.trim() &&
        (values.image?.length > 0 || !!values.existing_image_id || !!values.existing_image_url) &&
        !!values.url?.trim()
      );
    }
    return values.selectedItems?.length === 1;
  },
  buildPayload: async (values) => {
    if (values.mode === BANNER_MODES.CUSTOM) {
      const uploadedImage = values.image?.length > 0 ? await uploadMedia(values.image) : null;
      const imageId = uploadedImage?.public_id || values.existing_image_id;

      if (!imageId && !values.existing_image_url) {
        throw new Error('Banner image is missing');
      }

      return {
        name: values.name,
        ...(imageId ? { image_id: imageId } : { image_url: values.existing_image_url }),
        url: values.url,
      };
    }

    return values.selectedItems[0];
  },
  parseApiData: (module) => {
    const banner = module.banner || module;

    if (banner?.source || banner?.image_id) {
      return {
        mode: BANNER_MODES.CUSTOM,
        selectedItems: [],
        name: banner.name || '',
        image: [],
        existing_image_id: banner.image_id || null,
        existing_image_url: banner.image_url || null,
        url: banner.url || '',
      };
    }

    if (banner?.uid) {
      return {
        mode: BANNER_MODES.EXISTING,
        selectedItems: [banner],
        name: '',
        image: [],
        existing_image_id: null,
        existing_image_url: null,
        url: '',
      };
    }

    return defaultValues;
  },
  ConfigComponent: createBannerConfig(useAvailableItems),
});
